<ion-header>
  <ion-toolbar>
    <ion-title><strong>Defect Void for {{currentDefect?.server_vehicle_registration_when_created}}</strong></ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="confirm()" [strong]="true">Continue</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <section class="onboard-wrap onboard-wrap__vertical onboard-results">

    <div class="c-onboard-section-container">
      <section class="c-onboard-section c-defect-cancel">
        <div class="c-onboard-row">
          <div class="c-onboard-col">
            Cancellation reason:
          </div>
          <div class="c-onboard-col">
            <icon-input type="select" [selectFirst]="false" [enabled]="true" placeholder="Select cancellation reason..."
                  [options]="cancellationReasonOptions" [(value)]="cancellation.cancellation_reason" (valueChange)="onCancellationReasonChange($event)">
            </icon-input>
          </div>
        </div>
        <div class="c-onboard-row">
          <div class="c-onboard-col">
            Cancellation reason description:
          </div>
          <div class="c-onboard-col">
              <ion-textarea placeholder="Add an explaination..." [(ngModel)]="cancellation.cancellation_reason_description" class="note-field--input"></ion-textarea>
          </div>

        </div>
        <div class="c-onboard-row">
          <div class="c-onboard-col">
            <icon-input styles="dark" type="button" [loading]="isLoading" [enabled]="!isLoading && cancellation.cancellation_reason && cancellation.cancellation_reason_description" (action)="click_cancel()" 
              [value]="'Void Defect'" icon="create" ></icon-input>
          </div>
        </div>
      </section>
    </div>

  </section>



</ion-content>